export default __webpack_public_path__ + "static/media/6e8e8927-5a98-49ae-9123-db1798ec6d92.68f9c6b1.woff2";